export default __webpack_public_path__ + "static/media/ML_LOADING_FAILURE.04696dcc.svg";